// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

import { Button } from "src/UI";

export default class TestVideo {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }

    private _TestVideo?: vf.gui.Video;
    private _TestVideo1?: vf.gui.Video;
    private _TestVideo2?: vf.gui.Video;
    private _buttonList: vf.gui.Label[] = [];

    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        /** 绘制 */
        const _video = this._TestVideo = new vf.gui.Video();
        _video.src = "./docs/play/assets/video/friday.mp4";
        // _video.poster = './assets/bg.png';
        _video.width = 200;
        _video.x = 300;
        _video.height = 200;
        _video.forceElementDraw = true;
        (_video as any).videoGroup = "ccccc";
        uiStage.addChild(_video);

        const _video1 = this._TestVideo1 = new vf.gui.Video();
        _video1.src = "./docs/play/assets/video/friday.mp4";
        _video1.width = 200;
        _video1.x = 550;
        _video1.height = 200;
        (_video1 as any).videoGroup = "ccccc";
        uiStage.addChild(_video1);

        const _video2 = this._TestVideo2 = new vf.gui.Video();
        _video2.src = "./docs/play/assets/video/friday.mp4";
        _video2.width = 200;
        _video2.x = 800;
        _video2.height = 200;
        (_video2 as any).videoGroup = "ccccc";
        uiStage.addChild(_video2);

        setTimeout(() => {
            // _video.play();
            _video1.poster = './assets/btnbg.png';
            console.error("  _video autoplay  ");
        }, 2000);
        // setTimeout(() => {
        //     console.error("  _video1 autoplay  ");
        //     _video1.play();
        // }, 4000);
        // setTimeout(() => {
        //     console.error("  _video2 autoplay  ");
        //     _video2.play();
        // }, 6000);
        // setTimeout(() => {
        //     console.error("  _video autoplay  ");
        //     _video.play();
        // }, 8000);
        // const a = document.createElement('video');

        // a.src = "./docs/play/assets/video/friday.mp4";
        // document.body.appendChild(a);
        // a.width = a.height = 300;
        // a.poster = './assets/bg.png';
        // a.controls = true;

        // _video.poster = './assets/bg.png';
        // (_video as any).forceElementDraw = true;

        // _video.autoplay = true;

        // _video.controls = false;



        const pos = _video.toDomRectangle();
        console.error(" pos  ", pos);
        setTimeout(() => {
            const pos = _video.toDomRectangle();
            console.error(" pos  ", pos);
        }, 100);


        _video.on("canplay", () => {
            console.log("canplay");
        }, this);
        _video.on("loadeddata", () => {
            console.log("loadeddata");
        }, this);

        _video.on("play", () => {
            console.error("play  视频");
        }, this);
        _video.on("paused", () => {
            console.error("paused  视频");
        }, this);
        _video.on("ended", () => {
            console.error("ended  视频");
        }, this);


        // const vvvv = document.createElement("video");
        // document.body.appendChild(vvvv);
        // vvvv.addEventListener('ended', () => {
        //     console.error("vvvv  end");
        // });
        // vvvv.autoplay = true;
        // vvvv.src = "./docs/play/assets/video/friday.mp4";



        // _video.play();

        const button1 = this.createBtn("播放", () => {

            // _video.play();
            _video.autoplay = true;


            // _video.autoplay = true;
            // setTimeout(() => {
            //     console.error(" herre???");
            //     _video.src = "https://static.alonehero.com/al-320/p00-still.mp4";
            //     setTimeout(() => {
            //         _video.src = a;
            //     }, 5000);
            // }, 5000);
        });
        button1.style.left = 0;
        button1.style.top = 450;
        uiStage.addChild(button1);

        const button2 = this.createBtn("暂停", () => {
            _video.pause();
        });
        button2.style.left = 120;
        button2.style.top = 450;
        uiStage.addChild(button2);

        // const button3 = this.createBtn("隐藏controls", ()=>{
        //     if(_video.controls == true){
        //         _video.controls = false;
        //         button3.text = "显示controls";
        //     }else{
        //         _video.controls = true;
        //         button3.text = "隐藏controls";
        //     }
        // });
        // button3.style.left = 240;
        // button3.style.top = 450;
        // uiStage.addChild(button3);

        const button4 = this.createBtn("静音", () => {
            if (_video.muted == true) {
                _video.muted = false;
                button4.text = "静音";
            } else {
                _video.muted = true;
                button4.text = "取消静音";
            }
        });


        button4.style.left = 0;
        button4.style.top = 520;
        uiStage.addChild(button4);

        const button5 = this.createBtn("全屏", () => {
            _video.requestFullScreen();
        });
        button5.style.left = 120;
        button5.style.top = 520;
        uiStage.addChild(button5);

        const button6 = this.createBtn("到第3秒", () => {
            _video.exitFullscreen();
        });
        button6.style.left = 240;
        button6.style.top = 520;
        uiStage.addChild(button6);

        const button7 = this.createBtn("到第0秒", () => {
            _video.currentTime = 0;
        });
        button7.style.left = 0;
        button7.style.top = 590;
        uiStage.addChild(button7);

        const button8 = this.createBtn("调大音量", () => {
            _video.volume += 0.1;
        });
        button8.style.left = 120;
        button8.style.top = 590;
        uiStage.addChild(button8);



        const button9 = this.createBtn("减小音量", () => {
            _video.volume -= 0.1;
        });
        button9.style.left = 240;
        button9.style.top = 590;
        uiStage.addChild(button9);

        this.getButton('设置/取消src', () => {
            if (_video.src && _video.src != "") {
                _video.src = "";


            } else {
                console.warn("fddfdf",
                    _video.src);
                _video.src = "./docs/play/assets/video/friday.mp4";
                console.warn("fddfdf",
                    _video.src);
            }

        }, uiStage, 15, 0);



        this.getButton('设置/取消autoplay', () => {
            if (_video.autoplay !== true) {
                _video.autoplay = true;


            } else {
                _video.autoplay = false;
            }

        }, uiStage, 15, 0);



        this.getButton('设置/取消loop', () => {
            if (_video.loop !== true) {
                _video.loop = true;

            } else {
                _video.loop = false;
            }

        }, uiStage, 15, 0);



        this.getButton('设置/取消muted', () => {
            if (_video.muted !== true) {
                _video.muted = true;

            } else {
                _video.muted = false;
            }

        }, uiStage, 15, 0);



        // this.getButton('设置/取消poster', () => {
        //     if (_video.poster!== true) {
        //         _video.poster=true;

        //     } else {
        //         _video.poster= "assets/skin/Button/button_up.png";
        //     }

        // }, uiStage, 15, 0);

        this.getButton("静音  controls", () => {
            if (_video.controls == true) {
                _video.controls = false;
            } else {
                _video.controls = true;
            }
        }, uiStage, 15, 0);


        this.getButton('设置/取消currentTime', () => {
            if (_video.currentTime !== 6) {
                _video.currentTime = 6;

            } else {
                _video.currentTime = 3;
            }

        }, uiStage, 15, 0);



        // this.getButton('设置/取消duration', () => {
        //     if (_video.duration!== 6) {
        //         _video.duration=3;

        //     } else {
        //         _video.duration=3;
        //     }

        // }, uiStage, 15, 0);



        this.getButton('设置/取消volume', () => {
            if (_video.volume !== 6) {
                _video.volume = 6;

            } else {
                _video.volume = 3;
            }

        }, uiStage, 15, 0);




        let b3: boolean = false;
        let btn3 = this.getButton('设置/取消canplaythrough事件', () => {

            if (!b3) {

                b3 = true;
                _video.off("canplaythrough", hoverFun3);

            } else {
                b3 = false;
                _video.on("canplaythrough", hoverFun3);

            }


        }, uiStage, 15, 0);

        function hoverFun3() {
            console.log("canplaythrough");
        }



        let b4: boolean = false;
        let btn4 = this.getButton('设置/取消canplay事件', () => {

            if (!b4) {

                b4 = true;
                _video.off("canplay", hoverFun4);

            } else {
                b4 = false;
                _video.on("canplay", hoverFun4);

            }


        }, uiStage, 15, 0);

        function hoverFun4() {
            console.log("canplay");
        }


        let b5: boolean = false;
        let btn5 = this.getButton('设置/取消complete事件', () => {

            if (!b5) {

                b5 = true;
                _video.off("complete", hoverFun5);

            } else {
                b5 = false;
                _video.on("complete", hoverFun5);

            }


        }, uiStage, 15, 0);

        function hoverFun5() {
            console.log("complete");
        }



        let b6: boolean = false;
        let btn6 = this.getButton('设置/取消ended事件', () => {

            if (!b6) {

                b6 = true;
                _video.off("cended", hoverFun6);

            } else {
                b6 = false;
                _video.on("ended", hoverFun6);

            }


        }, uiStage, 15, 0);

        function hoverFun6() {
            console.log("ended");
        }



        let b7: boolean = false;
        let btn7 = this.getButton('设置/取消loadeddata事件', () => {

            if (!b7) {

                b7 = true;
                _video.off("loadeddata", hoverFun6);

            } else {
                b7 = false;
                _video.on("loadeddata", hoverFun6);

            }


        }, uiStage, 15, 0);

        function hoverFun7() {
            console.log("loadeddata");
        }



        let b8: boolean = false;
        let btn8 = this.getButton('设置/取消durationchange事件', () => {

            if (!b8) {

                b8 = true;
                _video.off("durationchange", hoverFun6);

            } else {
                b8 = false;
                _video.on("durationchange", hoverFun6);



            }



        }, uiStage, 15, 0);

        function hoverFun8() {
            console.log("durationchange");
        }



        let b9: boolean = false;
        let btn9 = this.getButton('设置/取消paused事件', () => {

            if (!b9) {

                b9 = true;
                _video.off("paused", hoverFun9);
            } else {
                b9 = false;
                _video.on("paused", hoverFun9);
            }
        }, uiStage, 15, 0);
        function hoverFun9() {
            console.log("paused");
        }
        this.getButton(' 释放 release', () => {

            _video.release();
        }, uiStage, 15, 0);



        //     let b10:boolean = false;
        //     let btn10= this.getButton('设置/取消play事件', ()=>{

        //         if (!b10) {

        //             b10=true;
        //             _video.on("play",  hoverFun10);
        //         } else {
        //             b10=false;
        //             _video.on("play",  hoverFun10);
        //         }
        //     }, uiStage, 15, 0 ,);
        //    function hoverFun10(){
        //     console.log("play");
        //     }








































    }

    private createBtn(text: string, clickFun: Function): vf.gui.Button {
        const button = new vf.gui.Button;
        button.text = text;
        button.up = "assets/skin/Button/button_up.png";
        button.down = "assets/skin/Button/button_down.png";
        button.move = "assets/skin/Button/button_move.png";
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, clickFun, this);
        button.style.width = 100;
        button.style.height = 50;
        return button;
    }


    private posY = 10;
    private getButton(title: string, fun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 24;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, fun);
        target.addChild(button);
        this.posY = this.posY + 25 + y;
        this._buttonList.push(button);
        return button;
    }


    private onRelease() {
        if (this._TestVideo) {
            this._TestVideo.removeAllListeners();
            this._TestVideo.parent && this._TestVideo.parent.removeChild(this._TestVideo);
            this._TestVideo.release();
            this._TestVideo = undefined;
        }
        if (this._buttonList && this._buttonList.length > 0) {
            this._buttonList.forEach(element => {
                element.removeAllListeners();
                element.parent && element.parent.removeChild(element);
                element.release();
            });
            this._buttonList = [];
        }
    }

}


